/**
 * @fileoverview GET handler for the "/analytics_dashboard/:app_group_id/email_engagement_by_device_class_data" endpoint
 */
/* eslint-disable camelcase */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { analyticsDashboardAppGroupIdEmailEngagementByDeviceClassData } from "./constants";
import type { analyticsDashboardAppGroupIdEmailEngagementByDeviceClassDataResult } from "./types";

export const getAnalyticsDashboardAppGroupIdEmailEngagementByDeviceClassData = reactQueryFetcherAdapter(
  analyticsDashboardAppGroupIdEmailEngagementByDeviceClassData,
  (
    signal: AbortSignal,
    app_group_id: string,
    start_date: number,
    end_date: number,
    metric: string
  ): Promise<analyticsDashboardAppGroupIdEmailEngagementByDeviceClassDataResult> => {
    return fetch(
      `/analytics_dashboard/${app_group_id}/email_engagement_by_device_class_data`,
      "GET",
      { start_date, end_date, metric },
      { signal }
    );
  }
);
